import axios, { AxiosError, AxiosResponse } from 'axios'
import { getCookie } from './cookies'
import { toast } from 'react-toastify'

export interface LinkEndpoint {
    endpoint: string,
    timeout: number
}

interface CrudLinksEndpoint {
    cadastrar: LinkEndpoint,
    todos: LinkEndpoint,
    consultar: LinkEndpoint,
    editar: LinkEndpoint,
}

export interface ReqResponse {
    status: number,
    data: any
}

// const baseUrl:string = 'https://admin.obportus.net'
const baseUrl: string = process.env.REACT_APP_ENV_CONFIG === 'dev' ? 'http://localhost:3000' : 'https://admin.obportus.net'

// const baseUrlNew:string = 'https://api.obportus.net'
const baseUrlNew: string = process.env.REACT_APP_ENV_CONFIG === 'dev' ? 'http://localhost:3002' : 'https://endpoint.obportus.net'

const baseSite: string = process.env.REACT_APP_ENV_CONFIG === 'dev' ? 'http://localhost:3001' : 'https://gestao.obportus.net'

export class ApiEndpoints {

    static apiOld: string = baseUrl
    static apiNew: string = baseUrlNew
    static baseSite: string = baseSite

    static baseUrl: string = baseUrl

    static login: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/usuario/login",
        // endpoint: baseUrl + "/auth/site",
        timeout: 20000
    }
    static loginUsuario: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/usuario/login/usuario",
        // endpoint: baseUrl + "/auth/site",
        timeout: 20000
    }
    static loginSite: LinkEndpoint = {
        endpoint: baseUrlNew + "/auth/site",
        // endpoint: baseUrl + "/auth/site",
        timeout: 20000
    }

    static logoff: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/usuario/logoff",
        timeout: 20000
    }

    static colaboradores: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/colaboradores",
        timeout: 20000
    }

    static colaborador: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/colaborador",
        timeout: 20000
    }

    static dadosFuncionario: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/colaborador/funcionario/dados",
        timeout: 20000
    }

    static colaboradorEditBasic: LinkEndpoint = {
        endpoint: baseUrl + "/api/colaborador/edit/basic",
        timeout: 20000
    }

    static colaboradorEditAccess: LinkEndpoint = {
        endpoint: baseUrl + "/api/colaborador/edit/access",
        timeout: 20000
    }

    static colaboradorCadastrar: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/colaborador/cadastrar",
        timeout: 20000
    }

    static colaboradorEditarBasic: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/editar/basic",
        timeout: 20000
    }

    static colaboradorEscalas: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas/consultar/todas",
        timeout: 20000
    }

    static colaboradorEscalasHistorico: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas/consultar/escalas_historico/colaborador",
        timeout: 20000
    }

    static colaboradorEscalaAlterar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/editar/escala",
        timeout: 20000
    }

    static colaboradorEscalaHistoricoAlterar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/editar/escala/historico",
        timeout: 20000
    }

    static nfSelecionarEmpresas: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/selecionarEmpresas",
        timeout: 15000
    }

    static nfConsultarEmpresa: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/nfsEmpresa",
        timeout: 15000
    }

    static nfFormData: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/formData",
        timeout: 15000
    }

    static nfCadastro: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/cadastrar",
        timeout: 20000
    }

    static nfEditar: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/editar",
        timeout: 20000
    }

    static nfEnviarAh: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/enviarAh",
        timeout: 20000
    }

    static nfConsultar: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/consultar",
        timeout: 15000
    }

    static nfXml: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/xml",
        timeout: 20000
    }

    static nfXmlDownload: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/xmlDownload",
        timeout: 30000
    }

    static nfPdf: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/pdf",
        timeout: 30000
    }

    static nfCancelar: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/cancelar",
        timeout: 20000
    }

    static nfDeletar: LinkEndpoint = {
        endpoint: baseUrl + "/api/nf/deletar",
        timeout: 20000
    }

    static nfFiltros: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/filtros",
        timeout: 15000
    }
    static nfseFiltros: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/filtros",
        timeout: 15000
    }

    static nfseDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/deletar",
        timeout: 20000
    }
    static nfseEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/editar",
        timeout: 20000
    }
    static nfseCancelar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/cancelar",
        timeout: 30000
    }
    static nfseEnviarEvento: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/enviar/evento",
        timeout: 30000
    }
    static nfseCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/cadastrar",
        timeout: 20000
    }

    static nfseConsultarISS: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/consultar/aliquotaISS",
        timeout: 30000
    }

    static nfseEmpresaSalvarCertificado: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/empresa/certificado/salvar",
        timeout: 20000
    }

    static nfseEmpresaSalvarDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/empresa/certificado/deletar",
        timeout: 20000
    }

    static nfseServicosConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servicos/consultar",
        timeout: 20000
    }

    static nfseServicoConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico/consultar",
        timeout: 20000
    }

    static nfseServicoCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico/cadastrar",
        timeout: 20000
    }

    static nfseServicoEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico/editar",
        timeout: 20000
    }

    static nfseServicoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico/deletar",
        timeout: 20000
    }

    static nfseServicosMunicipaisListar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servicos_mun/listar",
        timeout: 20000
    }

    static nfseServicoMunicipalConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico_mun/consultar",
        timeout: 20000
    }

    static nfseServicoMunicipalCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico_mun/cadastrar",
        timeout: 20000
    }

    static nfseServicoMunicipalEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico_mun/editar",
        timeout: 20000
    }

    static nfseServicoMunicipalDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/servico_mun/deletar",
        timeout: 20000
    }

    static nfsCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/cadastrar",
        timeout: 20000
    }

    static nfsEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/editar",
        timeout: 20000
    }

    static nfsEmissao: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/emitir",
        timeout: 30000
    }

    static nfsCancelar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/cancelar",
        timeout: 30000
    }

    static nfsDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/deletar",
        timeout: 20000
    }

    static nfsDownloadPDF: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/baixar/pdf",
        timeout: 30000
    }

    static nfsDownloadPath: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/baixar/pdf/path",
        timeout: 20000
    }

    static nfsDownloadLista: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/baixar/pdf/lista",
        timeout: 20000
    }

    static nfsDownloadXML: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/baixar/xml",
        timeout: 30000
    }

    static nfsDownloadRelatorioExcel: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/baixar/relatorio",
        timeout: 20000
    }

    static nfsEmpresa: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nfs/empresa",
        timeout: 15000
    }

    static nfseListar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/listar",
        timeout: 20000
    }
    static nfseListarCompetencias: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/listar/multiple",
        timeout: 20000
    }
    static nfseListarUltimasNotas: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/listar/cliente/ultimas/nfs",
        timeout: 20000
    }

    static nfseRelatorioExcel: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/baixar/relatorio",
        timeout: 30000
    }
    static nfseImportarXML: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/importar/xml",
        timeout: 30000
    }
    static nfseImportarPDF: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/importar/pdf",
        timeout: 30000
    }
    static nfseValidarPDFs: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/validar/pdf",
        timeout: 30000
    }

    static nfseModelos: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/modelos/listar",
        timeout: 15000
    }
    static nfseModeloConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/modelo/consultar",
        timeout: 20000
    }
    static nfseModeloCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/modelo/cadastrar",
        timeout: 20000
    }
    static nfseModeloEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/modelo/editar",
        timeout: 20000
    }
    static nfseModeloDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nfse/modelo/deletar",
        timeout: 20000
    }

    static nfsNota: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota",
        timeout: 20000
    }

    static nfEmpresas: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/empresas",
        timeout: 15000
    }

    static nfEmpresasInfos: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/empresas/infos",
        timeout: 15000
    }
    static nfEmpresasInfosNFSe: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/empresas/nfse/infos",
        timeout: 15000
    }

    static nfEmpresasCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/empresas/cadastrar",
        timeout: 20000
    }

    static nfEmpresasEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/empresas/editar",
        timeout: 20000
    }

    static nfEmpresasConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/empresas/consultar",
        timeout: 15000
    }

    static nfClientes: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/clientes",
        timeout: 15000
    }

    static nfClientesCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/clientes/cadastrar",
        timeout: 20000
    }

    static nfClientesEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/clientes/editar",
        timeout: 20000
    }

    static nfClientesExcluir: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/clientes/excluir",
        timeout: 20000
    }

    static nfClientesConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/clientes/consultar",
        timeout: 20000
    }

    static nfTiposClientesConsultarTodos: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/tipos/clientes/todos",
        timeout: 20000
    }

    static nfTiposClientesConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/tipos/clientes/consultar",
        timeout: 20000
    }

    static nfTiposClientesCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/tipos/clientes/cadastrar",
        timeout: 20000
    }

    static nfTiposClientesEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/tipos/clientes/editar",
        timeout: 20000
    }

    static nfTiposClientesExcluir: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/tipos/clientes/excluir",
        timeout: 20000
    }

    static nfModeloCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/modelo/cadastrar",
        timeout: 20000
    }

    static nfModeloConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/modelo",
        timeout: 20000
    }

    static nfModelosConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/modelos",
        timeout: 15000
    }

    static nfModeloEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/modelo/editar",
        timeout: 20000
    }

    static nfModeloDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/modelo/deletar",
        timeout: 20000
    }

    static nfImportarPlanilha: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/nota/planilha/importar",
        timeout: 20000
    }

    static nfImportarPlanilhaClientes: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/importar/clientes",
        timeout: 15000
    }

    static importarPlanilhaCnvColaboradores: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/importar/cnv",
        timeout: 20000
    }
    static importarPlanilhaCrachasColaboradores: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/crachas/importar",
        timeout: 20000
    }

    static relatorioCrachasColaboradores: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/crachas/relatorio",
        timeout: 20000
    }

    static importarPlanilhaCnvColaboradoresDownload: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/importar/cnv/relatorio",
        timeout: 20000
    }

    static nfImportarPlanilhaClientesCancelar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/importar/clientes/cancelar",
        timeout: 20000
    }

    static nfServicosConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servicos/consultar",
        timeout: 20000
    }

    static nfServicoConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servico/consultar",
        timeout: 20000
    }

    static nfServicoCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servico/cadastrar",
        timeout: 20000
    }

    static nfServicoEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servico/editar",
        timeout: 20000
    }

    static nfServicoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servico/deletar",
        timeout: 20000
    }

    static nfServicosEmpresasConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servicos/empresas/consultar",
        timeout: 20000
    }

    static nfServicosEmpresaConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servicos/empresa/consultar",
        timeout: 20000
    }

    static nfServicosEmpresaCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/servicos/empresa/cadastrar",
        timeout: 20000
    }

    static nfCidadesListar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/cidades/consultar",
        timeout: 20000
    }

    static nfCidadeConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/cidade/consultar",
        timeout: 20000
    }

    static nfCidadeCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/cidade/cadastrar",
        timeout: 20000
    }

    static nfCidadeEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/cidade/editar",
        timeout: 20000
    }

    static nfCidadeDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/cidade/deletar",
        timeout: 20000
    }

    static nfConfigConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/config/consultar",
        timeout: 20000
    }

    static nfConfigEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/nf/config/editar",
        timeout: 20000
    }
    
    static despesasMetricasFiltro: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/metricas/filtros",
        timeout: 20000
    }
    static despesasMetricasDados: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/metricas/dados",
        timeout: 20000
    }

    static despesasClientes: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/clientes",
        timeout: 20000
    }

    static despesasClienteConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cliente/consultar",
        timeout: 20000
    }

    static despesasClienteCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cliente/cadastrar",
        timeout: 20000
    }

    static despesasClienteEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cliente/editar",
        timeout: 20000
    }

    static despesasClienteDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cliente/deletar",
        timeout: 20000
    }

    static despesasFormasPagamento: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/formasPagamento",
        timeout: 20000
    }

    static despesasFormaPagamentoConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/formaPagamento/consultar",
        timeout: 20000
    }

    static despesasFormaPagamentoCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/formaPagamento/cadastrar",
        timeout: 20000
    }

    static despesasFormaPagamentoEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/formaPagamento/editar",
        timeout: 20000
    }

    static despesasFormaPagamentoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/formaPagamento/deletar",
        timeout: 20000
    }

    static despesasCartoes: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cartoes",
        timeout: 20000
    }

    static despesasCartaoConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cartao/consultar",
        timeout: 20000
    }

    static despesasCartaoDadosConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cartao/dados",
        timeout: 20000
    }

    static despesasCartaoCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cartao/cadastrar",
        timeout: 20000
    }

    static despesasCartaoEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cartao/editar",
        timeout: 20000
    }

    static despesasCartaoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/cartao/deletar",
        timeout: 20000
    }

    static despesasCategorias: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/categorias",
        timeout: 20000
    }

    static despesasCategoriaConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/categoria/consultar",
        timeout: 20000
    }

    static despesasCategoriaCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/categoria/cadastrar",
        timeout: 20000
    }

    static despesasCategoriaEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/categoria/editar",
        timeout: 20000
    }

    static despesasCategoriaDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/despesas/categoria/deletar",
        timeout: 20000
    }

    static frotaFiltrosDados: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/filtros",
        timeout: 20000
    }
    // static frotaFiltros:LinkEndpoint = {
    //     endpoint: baseUrl + "/api/painel/despesa/frota/filtros",
    //     timeout: 10000
    // }

    static frotaListar: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/listar",
        timeout: 20000
    }
    // static frotaListar:LinkEndpoint = {
    //     endpoint: baseUrl + "/api/painel/despesa/frota/listar",
    //     timeout: 10000
    // }

    static frotaListarRegistro: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/listar/registro",
        timeout: 20000
    }

    static frotaCadastro: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/cadastrar",
        timeout: 20000
    }
    // static frotaCadastro:LinkEndpoint = {
    //     endpoint: baseUrl + "/api/painel/despesa/frota/cadastro",
    //     timeout: 10000
    // }

    static frotaCusto: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/despesa/frota/custo",
        timeout: 20000
    }

    static frotaEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/editar",
        timeout: 20000
    }
    // static frotaEditar:LinkEndpoint = {
    //     endpoint: baseUrl + "/api/painel/despesa/frota/editar",
    //     timeout: 10000
    // }

    static frotaUploadAnexo: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/upload/anexo",
        timeout: 20000
    }

    static frotaDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/deletar",
        timeout: 20000
    }
    // static frotaDeletar:LinkEndpoint = {
    //     endpoint: baseUrl + "/api/painel/despesa/frota/deletar",
    //     timeout: 10000
    // }

    static frotaDeletarAnexo: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/deletar/anexo",
        timeout: 20000
    }

    static frotaRevisar: LinkEndpoint = {
        endpoint: baseUrlNew + "/frota/revisar",
        timeout: 20000
    }

    static pontoMarcacoes: LinkEndpoint = {
        endpoint: baseUrlNew + "/marcacoes/consultar",
        timeout: 20000
    }

    static pontoOcorrencias: LinkEndpoint = {
        endpoint: baseUrlNew + "/ocorrencias/todos",
        timeout: 20000
    }

    static pontoEscalas: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/listar",
        timeout: 20000
    }
    static pontoEscalaConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/consultar",
        timeout: 20000
    }
    static pontoEscalaCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/cadastrar",
        timeout: 20000
    }
    static pontoEscalaEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/editar",
        timeout: 20000
    }
    static pontoEscalaDias12x36: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/dias12x36",
        timeout: 20000
    }

    static pontoTiposEscalas: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/tipo_listar",
        timeout: 20000
    }
    static pontoTiposEscalasCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/tipo_cadastrar",
        timeout: 20000
    }
    static pontoTiposEscalasEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/tipo_editar",
        timeout: 20000
    }
    static pontoTiposEscalasConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/tipo_consultar",
        timeout: 20000
    }
    static pontoTiposEscalasDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/escalas_siteform/tipo_deletar",
        timeout: 20000
    }

    static insumosUnidades: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/unidades",
        timeout: 20000
    }
    static insumosUnidade: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/unidade",
        timeout: 20000
    }
    static insumosUnidadeDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/deletar/unidade",
        timeout: 20000
    }
    static insumosUnidadeEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/editar/unidade",
        timeout: 20000
    }
    static insumosUnidadeCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/cadastrar/unidade",
        timeout: 20000
    }
    static insumosFiltrosPedidos: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/filtros",
        timeout: 20000
    }
    static insumosPedidosGeral: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/pedidos/geral",
        timeout: 20000
    }
    static insumosEditarProdutosPedido: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/editar/pedido/produtos",
        timeout: 20000
    }
    static insumosRevisarPedido: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/editar/pedido/revisar",
        timeout: 20000
    }
    static insumosListarPedido: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/pedido",
        timeout: 20000
    }
    static insumosDownloadRelatorio: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/relatorio/fai",
        timeout: 20000
    }
    static insumosCadastrarPedido: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/cadastrar/pedido",
        timeout: 20000
    }
    static insumosDeletarPedido: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/deletar/pedido",
        timeout: 20000
    }

    static insumosProdutos: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/produtos",
        timeout: 20000
    }
    static insumosProduto: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/produto",
        timeout: 20000
    }
    static insumosProdutoEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/editar/produto",
        timeout: 20000
    }
    static insumosProdutoCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/cadastrar/produto",
        timeout: 20000
    }
    static insumosProdutoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/deletar/produto",
        timeout: 20000
    }
    
    static insumosLocais: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/locais",
        timeout: 20000
    }
    static insumosLocal: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/listar/local",
        timeout: 20000
    }
    static insumosLocalEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/editar/local",
        timeout: 20000
    }
    static insumosLocalCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/cadastrar/local",
        timeout: 20000
    }
    static insumosLocalDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos/deletar/local",
        timeout: 20000
    }
    static insumosConsultarEstoque: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos_estoque/consultar",
        timeout: 20000
    }
    static insumosFiltrosEstoque: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos_estoque/filtros",
        timeout: 20000
    }
    static insumosCadastrarEstoque: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos_estoque/cadastrar",
        timeout: 20000
    }
    static insumosEditarEstoque: LinkEndpoint = {
        endpoint: baseUrlNew + "/insumos_estoque/editar",
        timeout: 20000
    }

    static apuracaoFolhaPonto: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/relatorios/folhaDePonto",
        timeout: 20000
    }

    static apuracaoFolhaPontoArquivo: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/relatorios/folhaDePonto/colaborador",
        timeout: 20000
    }

    static apuracaoFolhaPontoCompactar: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/relatorios/folhaDePonto/compactar",
        timeout: 20000
    }

    static apuracaoFolhaPontoColaboradores: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/consultar/folha_ponto",
        timeout: 20000
    }

    static apuracaoConsultarFiltroDados: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/consultar/filtro/dados",
        timeout: 59000
    }

    static apuracaoConsultarDadosApuracao: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/consultar",
        timeout: 59000
    }

    static apuracaoCalcularDados: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/calcular",
        timeout: 59000
    }

    static apuracaoCalcularDadosDownload: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/calcular/download",
        timeout: 59000
    }
    static apuracaoDownloadFolhaPontoManual: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/download/folha",
        timeout: 59000
    }

    static apuracaoCalcularDadosTotaisDownload: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/calcular/download/totais",
        timeout: 59000
    }

    static apuracaoCalcularDadosDownloadPath: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/calcular/download/path",
        timeout: 59000
    }

    static apuracaoCalcularDadosDownloadVarios: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/calcular/download/varios",
        timeout: 59000
    }

    static apuracaoCalcularConsultarDados: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/calcular/consultar",
        timeout: 59000
    }

    static apuracaoOcorrenciaCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/ocorrencia/cadastrar",
        timeout: 20000
    }

    static apuracaoOcorrenciaCancelar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/ocorrencia/cancelar",
        timeout: 20000
    }

    static apuracaoOcorrenciaCancelarTodas: LinkEndpoint = {
        endpoint: baseUrlNew + "/ocorrencias/cancelar/periodo",
        timeout: 20000
    }

    static apuracaoAjusteCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/solicitacoes/cadastrar",
        timeout: 59000
    }

    static apuracaoAjusteEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/solicitacoes/editar",
        timeout: 59000
    }

    static apuracaoAjusteDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/solicitacoes/excluir",
        timeout: 20000
    }

    static apuracaoObservacaoRegistrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/observacao/registrar",
        timeout: 20000
    }

    static apuracaoObservacaoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/observacao/deletar",
        timeout: 20000
    }

    static apuracaoMarcacoesAtualizar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/marcacoes/atualizar",
        timeout: 20000
    }

    static apuracaoTrocaTurnoEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/troca_turno/editar",
        timeout: 20000
    }

    static apuracaoReferenciaSalvar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/referencia/salvar",
        timeout: 20000
    }

    static apuracaoReferenciaDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/apuracao/referencia/deletar",
        timeout: 20000
    }

    static apuracaoDownload: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/relatorios/folhaDePonto",
        timeout: 59000
    }

    static metricasConsultarLogsDia: LinkEndpoint = {
        endpoint: baseUrlNew + "/auth/logs/listar/dia",
        timeout: 20000
    }
    static metricasConsultarLogsSites: LinkEndpoint = {
        endpoint: baseUrlNew + "/contato/site/logs",
        timeout: 20000
    }

    static comunicadosTodos: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/todos",
        timeout: 20000
    }
    static comunicadosFiltros: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/colaboradores/filtros",
        timeout: 20000
    }
    static comunicadoConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/consultar",
        timeout: 20000
    }
    static comunicadoCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/cadastrar",
        timeout: 20000
    }
    static comunicadoEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/editar",
        timeout: 20000
    }
    static comunicadosEnviarNotificacao: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/enviar/notificacao",
        timeout: 20000
    }
    static comunicadoEnviarDocumento: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/upload/documento",
        timeout: 20000
    }
    static comunicadoEnviarImagemDestaque: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/upload/imagem_destaque",
        timeout: 20000
    }
    static comunicadoDeletarImagemDestaque: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/deletar/imagem_destaque",
        timeout: 20000
    }
    static comunicadoDeletarDocumento: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/deletar/documento",
        timeout: 20000
    }
    static comunicadoDownloadDocumento: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/download/documento",
        timeout: 20000
    }
    static comunicadoDownloadImagem: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/download/imagem_destaque",
        timeout: 20000
    }
    static comunicadoRelatorioVisualizacoes: LinkEndpoint = {
        endpoint: baseUrlNew + "/comunicados/relatorio/visualizacoes",
        timeout: 20000
    }

    static painelControle = {

        empresas: {
            cadastrar: {
                endpoint: baseUrlNew + "/painelControle/empresa/cadastrar",
                timeout: 20000
            },
            todos: {
                endpoint: baseUrlNew + "/painelControle/empresas/consultar",
                timeout: 20000
            },
            consultar: {
                endpoint: baseUrlNew + "/painelControle/empresa/consultar",
                timeout: 20000
            },
            editar: {
                endpoint: baseUrlNew + "/painelControle/empresa/editar",
                timeout: 20000
            },
        } as CrudLinksEndpoint,

        cargos: {
            cadastrar: {
                endpoint: baseUrlNew + "/painelControle/cargo/cadastrar",
                timeout: 20000
            },
            todos: {
                endpoint: baseUrlNew + "/painelControle/cargos/consultar",
                timeout: 20000
            },
            consultar: {
                endpoint: baseUrlNew + "/painelControle/cargo/consultar",
                timeout: 20000
            },
            editar: {
                endpoint: baseUrlNew + "/painelControle/cargo/editar",
                timeout: 20000
            }
        } as CrudLinksEndpoint,

        centros: {
            cadastrar: {
                endpoint: baseUrlNew + "/painelControle/centroCusto/cadastrar",
                timeout: 20000
            },
            todos: {
                endpoint: baseUrlNew + "/painelControle/centroCustos/consultar",
                timeout: 20000
            },
            consultar: {
                endpoint: baseUrlNew + "/painelControle/centroCusto/consultar",
                timeout: 20000
            },
            editar: {
                endpoint: baseUrlNew + "/painelControle/centroCusto/editar",
                timeout: 20000
            },
        } as CrudLinksEndpoint,

        locais: {
            cadastrar: {
                endpoint: baseUrlNew + "/painelControle/localTrabalho/cadastrar",
                timeout: 20000
            },
            todos: {
                endpoint: baseUrlNew + "/painelControle/locaisTrabalho/consultar",
                timeout: 20000
            },
            consultar: {
                endpoint: baseUrlNew + "/painelControle/localTrabalho/consultar",
                timeout: 20000
            },
            editar: {
                endpoint: baseUrlNew + "/painelControle/localTrabalho/editar",
                timeout: 20000
            },
        } as CrudLinksEndpoint,

        usuarios: {
            cadastrar: {
                endpoint: baseUrlNew + "/painelControle/usuario/cadastrar",
                timeout: 20000
            },
            todos: {
                endpoint: baseUrlNew + "/painelControle/usuarios/consultar",
                timeout: 20000
            },
            consultar: {
                endpoint: baseUrlNew + "/painelControle/usuario/consultar",
                timeout: 20000
            },
            editar: {
                endpoint: baseUrlNew + "/painelControle/usuario/editar",
                timeout: 20000
            },
        } as CrudLinksEndpoint,

        definicoesApp: {
            dados: {
                endpoint: baseUrlNew + "/painelControle/definicoesAppDados",
                timeout: 20000
            } as LinkEndpoint,
            editar: {
                endpoint: baseUrlNew + "/painelControle/definicoesAppDados/editar",
                timeout: 20000
            } as LinkEndpoint,
        },

        situacoes: {
            cadastrar: {
                endpoint: baseUrlNew + "/painelControle/situacao/cadastrar",
                timeout: 20000
            },
            todos: {
                endpoint: baseUrlNew + "/painelControle/situacoes/consultar",
                timeout: 20000
            },
            consultar: {
                endpoint: baseUrlNew + "/painelControle/situacao/consultar",
                timeout: 20000
            },
            editar: {
                endpoint: baseUrlNew + "/painelControle/situacao/editar",
                timeout: 20000
            },
        } as CrudLinksEndpoint,

    }

    static qrcodeFiltros: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/filtros",
        timeout: 20000
    }

    static qrcodeListar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcodes/filtrar",
        timeout: 20000
    }
    
    static qrcodeListarDownloadRelatorio: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/inativos",
        timeout: 20000
    }

    static qrcodeCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/cadastrar",
        timeout: 20000
    }

    static qrcodeEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/editar",
        timeout: 20000
    }

    static qrcodeInativar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/inativar",
        timeout: 20000
    }

    static qrcodeReativar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/reativar",
        timeout: 20000
    }

    static qrcodeCadastrarFiltros: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/cadastrar/filtros",
        timeout: 20000
    }

    static qrcodeConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/dados",
        timeout: 20000
    }

    static qrcodeRegistrosFiltros: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/registros/filtros",
        timeout: 20000
    }

    static qrcodeRegistros: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/registros",
        timeout: 20000
    }

    static qrcodeDownloadRegistros: LinkEndpoint = {
        endpoint: baseUrl + "/api/app/qrcodes/relatorios/dados",
        timeout: 20000
    }

    static qrcodeDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/deletar",
        timeout: 20000
    }

    static qrcodeRemoverNfc: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/qrcode/remover_nfc",
        timeout: 20000
    }

    static qrcodeRegistrosId: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode/site/registros/qrcode",
        timeout: 20000
    }
    
    static qrcodeRondaListar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode_ronda/listar",
        timeout: 20000
    }
    static qrcodeRondaConsultar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode_ronda/consultar",
        timeout: 20000
    }
    static qrcodeRondaCadastrar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode_ronda/cadastrar",
        timeout: 20000
    }
    static qrcodeRondaEditar: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode_ronda/editar",
        timeout: 20000
    }
    static qrcodeRondaFiltros: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode_ronda/filtros",
        timeout: 20000
    }
    static qrcodeRondaRegistros: LinkEndpoint = {
        endpoint: baseUrlNew + "/qrcode_ronda/registros",
        timeout: 20000
    }

    static documentosPendentes: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/pendentes",
        timeout: 20000
    }
    static documentosPasta: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/pasta",
        timeout: 20000
    }
    static documentoDados: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/dados",
        timeout: 20000
    }
    static documentosDeletados: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/deletados",
        timeout: 20000
    }
    static documentoRenomear: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/editar/nome",
        timeout: 20000
    }
    static documentoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/deletar/documento",
        timeout: 20000
    }
    static documentoDeletarPermanentemente: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/deletar/permanentemente",
        timeout: 20000
    }
    static documentoDeletarRestaurar: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/deletar/restaurar",
        timeout: 20000
    }
    static documentoListarPastas: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/pastas/listar",
        timeout: 20000
    }
    static documentoCriarPastas: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/pasta/criar",
        timeout: 20000
    }
    static documentoEditarPastas: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/pasta/editar",
        timeout: 20000
    }
    static documentoMoverPasta: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/editar/pasta",
        timeout: 20000
    }
    static documentoMoverPastas: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/pastas/mover",
        timeout: 20000
    }
    static documentoDeletarPastas: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/pasta/deletar",
        timeout: 20000
    }
    
    static documentoCriar: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/criar",
        timeout: 20000
    }
    static documentoCriarSignatarios: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/signatarios/criar",
        timeout: 20000
    }
    static documentoCriarAssinaturas: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/assinaturas/criar",
        timeout: 20000
    }
    static documentoFinalizar: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/finalizar",
        timeout: 20000
    }
    static documentoConsultarColaboradores: LinkEndpoint = {
        endpoint: baseUrl + "/api/painel/documentos/colaboradores",
        timeout: 20000
    }
    static documentosListarColaboradores: LinkEndpoint = {
        endpoint: baseUrlNew + "/documentos/dados/colaboradores",
        timeout: 20000
    }
    
    static documentoVerOriginal: LinkEndpoint = {
        endpoint: baseUrl + "/documento/original/",
        timeout: 20000
    }
    static documentoVerAssinado: LinkEndpoint = {
        endpoint: baseUrl + "/documento/assinado/",
        timeout: 20000
    }

    static colaboradoresCrachaHistoricoAdicionar: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/crachas/adicionar",
        timeout: 20000
    }
    static colaboradoresCrachaHistoricoDeletar: LinkEndpoint = {
        endpoint: baseUrlNew + "/colaboradores/crachas/deletar",
        timeout: 20000
    }

}

export async function reqPostNoAuth(url: LinkEndpoint, data: any): Promise<ReqResponse> {

    const link: string = url.endpoint

    let apiResponse: AxiosResponse
    let apiError: AxiosError
    let apiErrorCheck: Boolean = false

    await axios.post(link, data, {
        timeout: url.timeout,
        headers: {
            "Content-type": "application/json"
        }
    }).then(function (response: AxiosResponse) {
        apiResponse = response
        return response
    }).catch(function (error: AxiosError) {
        apiError = error
        apiErrorCheck = true
        return error
    })

    if (apiErrorCheck === true) {
        if (apiError!.response?.status === 401) {
            const response: ReqResponse = {
                data: null,
                status: apiError!.response.status
            }

            return response
        }

        console.log(apiError!)
        const response: ReqResponse = {
            data: null,
            status: 0
        }

        return response
    }

    const response: ReqResponse = {
        data: apiResponse!.data,
        status: apiResponse!.status
    }

    return response



}

export async function reqGet(url: LinkEndpoint): Promise<ReqResponse> {

    const link: string = url.endpoint
    const token: string = getCookie('token')
    const id_usuario: string = getCookie('id_user')

    let apiResponse: AxiosResponse
    let apiError: AxiosError
    let apiErrorCheck: Boolean = false

    await axios.get(link, {
        timeout: url.timeout,
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`,
            "id_usuario": id_usuario,
        }
    }).then(function (response: AxiosResponse) {
        apiResponse = response
        return response
    }).catch(function (error: AxiosError) {
        apiError = error
        apiErrorCheck = true
        return error
    })

    if (apiErrorCheck === true) {
        console.log(apiError!)
        const response: ReqResponse = {
            data: null,
            status: 0
        }

        return response
    }

    const response: ReqResponse = {
        data: apiResponse!.data,
        status: apiResponse!.status
    }

    return response

}

export async function reqPost(url: LinkEndpoint, data: any): Promise<ReqResponse> {

    const link: string = url.endpoint
    const token: string = getTokenApi(url.endpoint)
    const id_usuario: string = getCookie('id_user')

    let apiResponse: AxiosResponse
    let apiError: AxiosError
    let apiErrorCheck: Boolean = false

    await axios.post(link, data, {
        timeout: url.timeout,
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`,
            "id_usuario": id_usuario,
        },
    }).then(function (response: AxiosResponse) {
        apiResponse = response
        return response
    }).catch(function (error: AxiosError) {
        apiError = error
        apiErrorCheck = true
        return error
    })

    if (apiErrorCheck === true) {
        console.log(apiError!)

        if (apiError!.response?.status === 400) {
            let msg: any = apiError!.response?.data
            return {
                data: msg,
                status: 400
            }
        }

        const response: ReqResponse = {
            data: null,
            status: 0
        }

        return response
    }

    const response: ReqResponse = {
        data: apiResponse!.data,
        status: apiResponse!.status
    }

    return response

}

export async function reqGetNew(url: LinkEndpoint): Promise<ReqResponse> {

    const link: string = url.endpoint
    const token: string = getTokenApi(url.endpoint)
    const id_usuario: string = getCookie('id_user')

    let apiResponse: AxiosResponse
    let apiError: AxiosError
    let apiErrorCheck: Boolean = false

    await axios.get(link, {
        timeout: url.timeout,
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`,
            "id_usuario": id_usuario,
        }
    }).then(function (response: AxiosResponse) {
        apiResponse = response
        return response
    }).catch(function (error: AxiosError) {
        apiError = error
        apiErrorCheck = true
        return error
    })

    if (apiErrorCheck === true) {
        console.log(apiError!)
        if (apiError!.code === "ERR_NETWORK") {
            toast.warning("Sem conexão!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        if (apiError!.code === "ECONNABORTED") {
            toast.warning("Sem conexão/timeout!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        if (apiError!.response !== undefined) {
            const status = apiError!.response.status

            if (status === 404 || status === 400) {
                const data: any = apiError!.response.data
                const messageData: string | string[] = data.message
                let msg: string = ""

                if (typeof (messageData) === "string") {
                    msg = messageData
                }

                if (typeof (messageData) === "object") {
                    msg = messageData[0]
                }

                toast.warning(msg, {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }

            if (status === 500) {
                toast.warning("Erro na API, tente novamente mais tarde ou verifique com o suporte!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        }

        const response: ReqResponse = {
            data: null,
            status: 0
        }

        return response
    }

    const response: ReqResponse = {
        data: apiResponse!.data,
        status: apiResponse!.status
    }

    return response

}

export async function reqPostNew(url: LinkEndpoint, data: any): Promise<ReqResponse> {

    const link: string = url.endpoint
    const token: string = getTokenApi(url.endpoint)
    const id_usuario: string = getCookie('id_user')

    let apiResponse: AxiosResponse
    let apiError: AxiosError
    let apiErrorCheck: Boolean = false

    await axios.post(link, data, {
        timeout: url.timeout,
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`,
            "id_usuario": id_usuario,
        }
    }).then(function (response: AxiosResponse) {
        apiResponse = response
        return response
    }).catch(function (error: AxiosError) {
        apiError = error
        apiErrorCheck = true
        return error
    })

    if (apiErrorCheck === true) {
        if (apiError!.code === "ERR_NETWORK") {
            toast.warning("Sem conexão!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        if (apiError!.code === "ECONNABORTED") {
            toast.warning("Sem conexão/timeout!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        console.log(apiError!)

        if (apiError!.response !== undefined) {
            const status = apiError!.response.status

            if (status === 404 || status === 400) {
                const data: any = apiError!.response.data
                const messageData: string | string[] = data.message
                let msg: string = ""

                if (typeof (messageData) === "string") {
                    msg = messageData
                }

                if (typeof (messageData) === "object") {
                    msg = messageData[0]
                }

                toast.warning(msg, {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })

                const response: ReqResponse = {
                    data: { message: msg },
                    status: status
                }

                return response
            }

            if (status === 500) {
                toast.warning("Erro na API, tente novamente mais tarde ou verifique com o suporte!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        }

        const response: ReqResponse = {
            data: null,
            status: 0
        }

        return response
    }

    const response: ReqResponse = {
        data: apiResponse!.data,
        status: apiResponse!.status
    }

    return response

}

export async function reqPatch(url: LinkEndpoint, data: any): Promise<ReqResponse> {

    const link: string = url.endpoint
    const token: string = getTokenApi(url.endpoint)
    const id_usuario: string = getCookie('id_user')

    let apiResponse: AxiosResponse
    let apiError: AxiosError
    let apiErrorCheck: Boolean = false

    await axios.patch(link, data, {
        timeout: url.timeout,
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`,
            "id_usuario": id_usuario,
        }
    }).then(function (response: AxiosResponse) {
        apiResponse = response
        return response
    }).catch(function (error: AxiosError) {
        apiError = error
        apiErrorCheck = true
        return error
    })

    if (apiErrorCheck === true) {
        if (apiError!.code === "ERR_NETWORK") {
            toast.warning("Sem conexão!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        if (apiError!.code === "ECONNABORTED") {
            toast.warning("Sem conexão/timeout!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        console.log(apiError!)

        if (apiError!.response !== undefined) {
            const status = apiError!.response.status

            if (status === 404 || status === 400) {
                const data: any = apiError!.response.data
                const messageData: string | string[] = data.message
                let msg: string = ""

                if (typeof (messageData) === "string") {
                    msg = messageData
                }

                if (typeof (messageData) === "object") {
                    msg = messageData[0]
                }

                toast.warning(msg, {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }

            if (status === 500) {
                toast.warning("Erro na API, tente novamente mais tarde ou verifique com o suporte!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        }

        const response: ReqResponse = {
            data: null,
            status: 0
        }

        return response
    }

    const response: ReqResponse = {
        data: apiResponse!.data,
        status: apiResponse!.status
    }

    return response

}

export async function reqPut(url: LinkEndpoint, data: any): Promise<ReqResponse> {

    const link: string = url.endpoint
    const token: string = getTokenApi(url.endpoint)
    const id_usuario: string = getCookie('id_user')

    let apiResponse: AxiosResponse
    let apiError: AxiosError
    let apiErrorCheck: Boolean = false

    await axios.put(link, data, {
        timeout: url.timeout,
        headers: {
            "Content-type": "application/json",
            "Authorization": `Bearer ${token}`,
            "id_usuario": id_usuario,
        }
    }).then(function (response: AxiosResponse) {
        apiResponse = response
        return response
    }).catch(function (error: AxiosError) {
        apiError = error
        apiErrorCheck = true
        return error
    })

    if (apiErrorCheck === true) {
        if (apiError!.code === "ERR_NETWORK") {
            toast.warning("Sem conexão!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        if (apiError!.code === "ECONNABORTED") {
            toast.warning("Sem conexão/timeout!", {
                containerId: 1,
                position: 'top-center',
                theme: 'dark'
            })
        }

        console.log(apiError!)

        if (apiError!.response !== undefined) {
            const status = apiError!.response.status

            if (status === 404 || status === 400) {
                const data: any = apiError!.response.data
                const messageData: string | string[] = data.message
                let msg: string = ""

                if (typeof (messageData) === "string") {
                    msg = messageData
                }

                if (typeof (messageData) === "object") {
                    msg = messageData[0]
                }

                toast.warning(msg, {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }

            if (status === 500) {
                toast.error("Erro na API, tente novamente mais tarde ou verifique com o suporte!", {
                    containerId: 1,
                    position: 'top-center',
                    theme: 'dark'
                })
            }
        }

        const response: ReqResponse = {
            data: null,
            status: 0
        }

        return response
    }

    const response: ReqResponse = {
        data: apiResponse!.data,
        status: apiResponse!.status
    }

    return response

}

export async function reqPostDownloadFile(url: LinkEndpoint, data: any, filename: string): Promise<ReqResponse> {

    let statusCode = await new Promise(function (resolve, reject) {
        let request = new XMLHttpRequest();
        let token = getTokenApi(url.endpoint)
        let id_usuario = getCookie('id_user')
        let link = url.endpoint

        request.responseType = "blob";
        request.open("POST", link, true)
        request.setRequestHeader("Content-Type", "application/json")
        request.setRequestHeader("Authorization", `Bearer ${token}`)
        request.setRequestHeader("id_usuario", id_usuario)
        request.send(JSON.stringify(data))

        request.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                const imageURL = window.URL.createObjectURL(this.response)

                const anchor = document.createElement("a")
                anchor.href = imageURL
                anchor.download = filename
                document.body.appendChild(anchor)
                anchor.click()

                resolve(200)

            } else if (this.status === 400) {

                resolve(400)

            }

            resolve(this.status)

        }
    })

    return {
        "status": Number(statusCode),
        "data": null
    }

}

export async function reqGetDownloadFile(url: LinkEndpoint, filename: string): Promise<ReqResponse> {

    let statusCode = await new Promise(function (resolve, reject) {
        let request = new XMLHttpRequest();
        let token = getTokenApi(url.endpoint)
        let id_usuario = getCookie('id_user')
        let link = url.endpoint

        request.responseType = "blob";
        request.open("GET", link, true)
        request.setRequestHeader("Content-Type", "application/json")
        request.setRequestHeader("Authorization", `Bearer ${token}`)
        request.setRequestHeader("id_usuario", id_usuario)
        request.send()

        request.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                const imageURL = window.URL.createObjectURL(this.response)

                const anchor = document.createElement("a")
                anchor.href = imageURL
                anchor.download = filename
                document.body.appendChild(anchor)
                anchor.click()

                resolve(200)

            } else if (this.status === 400) {

                resolve(400)

            }

            resolve(this.status)

        }
    })

    return {
        "status": Number(statusCode),
        "data": null
    }

}

function getTokenApi(url: string) {
    const urlBase = url.split("/")[2]
    const apiBaseNew = baseUrlNew.split("//")[1]
    if (urlBase === apiBaseNew) {
        return getCookie("token")
    }
    const apiBaseOld = baseUrl.split("//")[1]
    if (urlBase === apiBaseOld) {
        return getCookie("token2")
    }
    return ""
}
